import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/questionnaire/demographics-small.png'
import _imports_1 from '../assets/questionnaire/demographics-big.png'
import _imports_2 from '../assets/questionnaire/srl-capabilities-small.png'
import _imports_3 from '../assets/questionnaire/srl-capabilities-big.png'
import _imports_4 from '../assets/questionnaire/environmental-factors-small.png'
import _imports_5 from '../assets/questionnaire/environmental-factors-big.png'
import _imports_6 from '../assets/questionnaire/network-characteristics-small.png'
import _imports_7 from '../assets/questionnaire/network-characteristics-big.png'
import _imports_8 from '../assets/questionnaire/organizational-governance-small.png'
import _imports_9 from '../assets/questionnaire/organizational-governance-big.png'
import _imports_10 from '../assets/questionnaire/organizational-architecture-small.png'
import _imports_11 from '../assets/questionnaire/organizational-architecture-big.png'
import _imports_12 from '../assets/questionnaire/technical-IT-infrastructure-small.png'
import _imports_13 from '../assets/questionnaire/technical-IT-infrastructure-big.png'
import _imports_14 from '../assets/questionnaire/human-IT-infrastructure-small.png'
import _imports_15 from '../assets/questionnaire/human-IT-infrastructure-big.png'
import _imports_16 from '../assets/questionnaire/organizational-culture-small.png'
import _imports_17 from '../assets/questionnaire/organizational-culture-big.png'
import _imports_18 from '../assets/questionnaire/human-knowledge-and-skills-small.png'
import _imports_19 from '../assets/questionnaire/human-knowledge-and-skills-big.png'


const _withScopeId = n => (_pushScopeId("data-v-74013168"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = {
  class: "flex py-6",
  style: {"justify-content":"flex-end"}
}
const _hoisted_3 = { class: "stepper" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  height: "40"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  height: "40"
}
const _hoisted_6 = {
  key: 0,
  src: _imports_2,
  height: "40"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_3,
  height: "40"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_4,
  height: "40"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_5,
  height: "40"
}
const _hoisted_10 = {
  key: 0,
  src: _imports_6,
  height: "40"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_7,
  height: "40"
}
const _hoisted_12 = {
  key: 0,
  src: _imports_8,
  height: "40"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_9,
  height: "40"
}
const _hoisted_14 = {
  key: 0,
  src: _imports_10,
  height: "40"
}
const _hoisted_15 = {
  key: 1,
  src: _imports_11,
  height: "40"
}
const _hoisted_16 = {
  key: 0,
  src: _imports_12,
  height: "40"
}
const _hoisted_17 = {
  key: 1,
  src: _imports_13,
  height: "40"
}
const _hoisted_18 = {
  key: 0,
  src: _imports_14,
  height: "40"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_15,
  height: "40"
}
const _hoisted_20 = {
  key: 0,
  src: _imports_16,
  height: "40"
}
const _hoisted_21 = {
  key: 1,
  src: _imports_17,
  height: "40"
}
const _hoisted_22 = {
  key: 0,
  src: _imports_18,
  height: "40"
}
const _hoisted_23 = {
  key: 1,
  src: _imports_19,
  height: "40"
}
const _hoisted_24 = {
  class: "questions-panel",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_25 = { class: "buttonsQuestionaire flex" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  id: "submit",
  style: {"align-self":"flex-end"}
}
const _hoisted_29 = {
  class: "m-0",
  style: {"flex-direction":"column","width":"fit-content","margin-left":"auto","padding":"24px 24px"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-2 font-bold" }, "Progress", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QDemographics = _resolveComponent("QDemographics")!
  const _component_QEnvironmentalFactors = _resolveComponent("QEnvironmentalFactors")!
  const _component_QNetworkCharacteristics = _resolveComponent("QNetworkCharacteristics")!
  const _component_QOrganizationalGovernance = _resolveComponent("QOrganizationalGovernance")!
  const _component_QOrganizationalArchitecture = _resolveComponent("QOrganizationalArchitecture")!
  const _component_QTechnicalITInfrastructure = _resolveComponent("QTechnicalITInfrastructure")!
  const _component_QHumanITInfrastructure = _resolveComponent("QHumanITInfrastructure")!
  const _component_QOrganizationalCulture = _resolveComponent("QOrganizationalCulture")!
  const _component_QHumanKnowledgeandSkills = _resolveComponent("QHumanKnowledgeandSkills")!
  const _component_QSRLCapabilities = _resolveComponent("QSRLCapabilities")!
  const _component_IciButton = _resolveComponent("IciButton")!
  const _component_Knob = _resolveComponent("Knob")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {this.$forceUpdate(); _ctx.select(9)})
        }, [
          (_ctx.activeQuestion > 9)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion <= 9)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {this.$forceUpdate(); _ctx.select(117)})
        }, [
          (!(_ctx.activeQuestion >= 117 && _ctx.activeQuestion <= 149))
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 117 && _ctx.activeQuestion <= 149)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => {this.$forceUpdate(); _ctx.select(10);})
        }, [
          (!(_ctx.activeQuestion >= 10 && _ctx.activeQuestion <= 21))
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 10 && _ctx.activeQuestion <= 21)
            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[3] || (_cache[3] = ($event: any) => {this.$forceUpdate(); _ctx.select(22)})
        }, [
          (!(_ctx.activeQuestion >= 22 && _ctx.activeQuestion <= 39))
            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 22 && _ctx.activeQuestion <= 39)
            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[4] || (_cache[4] = ($event: any) => {this.$forceUpdate(); _ctx.select(40)})
        }, [
          (!(_ctx.activeQuestion >= 40 && _ctx.activeQuestion <= 54))
            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 40 && _ctx.activeQuestion <= 54)
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[5] || (_cache[5] = ($event: any) => {this.$forceUpdate(); _ctx.select(55)})
        }, [
          (!(_ctx.activeQuestion >= 55 && _ctx.activeQuestion <= 63))
            ? (_openBlock(), _createElementBlock("img", _hoisted_14))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 55 && _ctx.activeQuestion <= 63)
            ? (_openBlock(), _createElementBlock("img", _hoisted_15))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[6] || (_cache[6] = ($event: any) => {this.$forceUpdate(); _ctx.select(64)})
        }, [
          (!(_ctx.activeQuestion >= 64 && _ctx.activeQuestion <= 83))
            ? (_openBlock(), _createElementBlock("img", _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 64 && _ctx.activeQuestion <= 83)
            ? (_openBlock(), _createElementBlock("img", _hoisted_17))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[7] || (_cache[7] = ($event: any) => {this.$forceUpdate(); _ctx.select(84)})
        }, [
          (!(_ctx.activeQuestion >= 84 && _ctx.activeQuestion <= 97))
            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 84 && _ctx.activeQuestion <= 97)
            ? (_openBlock(), _createElementBlock("img", _hoisted_19))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[8] || (_cache[8] = ($event: any) => {this.$forceUpdate(); _ctx.select(98)})
        }, [
          (!(_ctx.activeQuestion >= 98 && _ctx.activeQuestion <= 109))
            ? (_openBlock(), _createElementBlock("img", _hoisted_20))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 98 && _ctx.activeQuestion <= 109)
            ? (_openBlock(), _createElementBlock("img", _hoisted_21))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "flow-item",
          onClick: _cache[9] || (_cache[9] = ($event: any) => {this.$forceUpdate(); _ctx.select(110)})
        }, [
          (!(_ctx.activeQuestion >= 110 && _ctx.activeQuestion <= 116))
            ? (_openBlock(), _createElementBlock("img", _hoisted_22))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion >= 110 && _ctx.activeQuestion <= 116)
            ? (_openBlock(), _createElementBlock("img", _hoisted_23))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        (_ctx.activeQuestion <= 9)
          ? (_openBlock(), _createBlock(_component_QDemographics, {
              key: 0,
              "active-question": this.activeQuestion
            }, null, 8, ["active-question"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 10 && _ctx.activeQuestion <= 21)
          ? (_openBlock(), _createBlock(_component_QEnvironmentalFactors, {
              key: 1,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 10 && this.activeQuestion <= 14 ? 0 : (this.activeQuestion >= 15 && this.activeQuestion <= 18 ? 1 : 2))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 22 && _ctx.activeQuestion <= 39)
          ? (_openBlock(), _createBlock(_component_QNetworkCharacteristics, {
              key: 2,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 22 && this.activeQuestion <= 25 ? 0 : (this.activeQuestion >= 26 && this.activeQuestion <= 29 ? 1 : (this.activeQuestion >= 30 && this.activeQuestion <= 33 ? 2 : this.activeQuestion >= 34 && this.activeQuestion <= 36 ? 3 : 4)))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 40 && _ctx.activeQuestion <= 54)
          ? (_openBlock(), _createBlock(_component_QOrganizationalGovernance, {
              key: 3,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 40 && this.activeQuestion <= 44 ? 0 : (this.activeQuestion >= 45 && this.activeQuestion <= 47 ? 1 : (this.activeQuestion >= 48 && this.activeQuestion <= 51 ? 2 : 3)))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 55 && _ctx.activeQuestion <= 63)
          ? (_openBlock(), _createBlock(_component_QOrganizationalArchitecture, {
              key: 4,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 55 && this.activeQuestion <= 57 ? 0 : (this.activeQuestion >= 58 && this.activeQuestion <= 60 ? 1 : 2))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 64 && _ctx.activeQuestion <= 83)
          ? (_openBlock(), _createBlock(_component_QTechnicalITInfrastructure, {
              key: 5,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 64 && this.activeQuestion <= 67 ? 0 : (this.activeQuestion >= 68 && this.activeQuestion <= 71 ? 1 : (this.activeQuestion >= 72 && this.activeQuestion <= 75 ? 2 : this.activeQuestion >= 76 && this.activeQuestion <= 79 ? 3 : 4)))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 84 && _ctx.activeQuestion <= 97)
          ? (_openBlock(), _createBlock(_component_QHumanITInfrastructure, {
              key: 6,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 84 && this.activeQuestion <= 88 ? 0 : (this.activeQuestion >= 89 && this.activeQuestion <= 92 ? 1 : 2))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 98 && _ctx.activeQuestion <= 109)
          ? (_openBlock(), _createBlock(_component_QOrganizationalCulture, {
              key: 7,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 98 && this.activeQuestion <= 100 ? 0 : (this.activeQuestion >= 101 && this.activeQuestion <= 104 ? 1 : 2))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 110 && _ctx.activeQuestion <= 116)
          ? (_openBlock(), _createBlock(_component_QHumanKnowledgeandSkills, {
              key: 8,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 110 && this.activeQuestion <= 113 ? 0 : 1)
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        (_ctx.activeQuestion >= 117 && _ctx.activeQuestion <= 149)
          ? (_openBlock(), _createBlock(_component_QSRLCapabilities, {
              key: 9,
              "active-question": this.activeQuestion,
              activeSub: (this.activeQuestion >= 117 && this.activeQuestion <= 128 ? 0 : (this.activeQuestion >= 129 && this.activeQuestion <= 139 ? 1 : 2))
            }, null, 8, ["active-question", "activeSub"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.activeQuestion > 9)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_IciButton, {
                  id: "prev",
                  content: _ctx.constructLabel(_ctx.buttonPreviousContent, _ctx.$t('questionnaireForm.btnLabelPrevious')),
                  onButtonClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.previous())),
                  btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;"
                }, null, 8, ["content"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion != 116)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_component_IciButton, {
                  id: "next",
                  content: _ctx.constructLabel(_ctx.buttonNextContent, _ctx.$t('questionnaireForm.btnLabelNext')),
                  onButtonClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.next())),
                  btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;"
                }, null, 8, ["content"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeQuestion == 116)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_IciButton, {
                  id: "submit",
                  content: _ctx.$t('questionnaireForm.btnLabelSubmit'),
                  onButtonClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submit())),
                  btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;"
                }, null, 8, ["content"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createVNode(_component_Knob, {
          class: "knob flex",
          style: {"justify-content":"center"},
          "model-value": _ctx.User.get().invitation.response.progress,
          valueColor: "#5EBCB8",
          valueTemplate: "{value}%"
        }, null, 8, ["model-value"])
      ])
    ])
  ]))
}